import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';
import { init } from './core/init';

const worker = new Worker(`${process.env.PUBLIC_URL}/new-events.worker.js`);
init();

const App = lazy(() => import('./App'));
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

export { worker };
